import { render } from "./App.vue?vue&type=template&id=8cb78e2e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8cb78e2e&lang=scss"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__